import './AnnouncementSearch.scss';
import { TextBox, Button } from 'devextreme-react/text-box';
import { useEffect, useRef, useState } from 'react';
import Mark from "mark.js";

export default function AnnouncementSearch(props: { elementToSearch: HTMLElement, onMarkElement?: (element: Element) => void }) {

	const [searchString, setSearchString] = useState('');
	const [searchResults, setSearchResults] = useState('');

	const timerRef = useRef();

	useEffect(() => {
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => {
			const markInstance = new Mark(props.elementToSearch);
			markInstance.unmark({
				done: () => {
					if (searchString) {
						markInstance.mark(searchString, {
							separateWordSearch: false,
							each: (element) => {
								if (props.onMarkElement) {
									props.onMarkElement(element);
								}
							},
							done: (marksTotal: number) => {
								setSearchResults(marksTotal === 0 ? 'No results found' : marksTotal === 1 ? "1 result found" :
									marksTotal + " results found");
							}
						});
					}
					else {
						setSearchResults('');
					}
				}
			});
		}, 500) as any;
	}, [searchString]);

	return (
		<div className='announcement-search'>
			<TextBox value={searchString}
				placeholder="Search announcement..."
				valueChangeEvent="input"
				onValueChanged={(e) => setSearchString(e.value)}
				mode="search"
			/>
			<div className='search-result'>{searchResults}</div>
		</div>
	)
} 
